export class DocUtils {
    static excludeDeleted(docs) {
        return docs.filter(doc => !doc.deleted_date && !doc.deleted_by);
    }
}
